import script from "./ShareDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareDialog.vue?vue&type=script&setup=true&lang=js"

import "./ShareDialog.vue?vue&type=style&index=0&id=b7668fda&lang=css"

const __exports__ = script;

export default __exports__